// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterCallToActionForm_root__Rqclu","input":"NewsletterCallToActionForm_input__25I75"};